import { FunctionComponent, useContext, useState } from "react";
import styles from "./FilterDropdown.module.css";
import FilterTitle from "./FilterTitle";
import { AffiliateTypeListMenu, ResetApplyButtons } from "../../../../helper";
import { globalContext } from "../../../../Provider/AppProvider";
import images from "../../../../assets/images";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useLazyQuery } from "@apollo/client";
import { AFFILIATE_TYPE, AFFILIATE_TYPE_BOTH } from "../../../../features/Affiliate/api/AffiliateQuery";


interface filterdropdownprops {
    handleCloseFilterDropDown: () => void
}

export interface AffiliateType{
    name: string,
}

const AffiliateFilterDropdown: FunctionComponent<filterdropdownprops> = ({handleCloseFilterDropDown}) => {
    const { dropdownIcon } = images;
    const {globalState,handleGlobalState} = useContext<any>(globalContext);
    const [anchorEl, setAnchorEl] = useState<EventTarget | null>(null);
    const [typeName , setTypeName] = useState<string>(globalState.affiliateFilter.typeName || "");
    const [statusRadio, setStatusRadio] = useState<string | null>(globalState.affiliateFilter.status || null);
    const open = Boolean(anchorEl);
    const [affiliateTypeListData,setAffiliateTypeList] = useState<AffiliateType[]>();
    const [affiliateTypeQuery] = useLazyQuery(AFFILIATE_TYPE,{
        fetchPolicy:"no-cache",
        onCompleted:(data)=>{
          setAffiliateTypeList(data?.affiliate_type?.map((data: { type: string; })=>({name: data?.type})));
        }
    })

    const [affiliateTypeBoth] = useLazyQuery(AFFILIATE_TYPE_BOTH,{
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
          const tempState = {...globalState};
          tempState.affiliateFilter.typeName = data?.affiliate_type?.[0]?.type || "Both";
          setTypeName(data?.affiliate_type?.[0]?.type || "Both");
          handleGlobalState(tempState)
        }
      })

    const handleSubmitManageFilter = () => {
        const tempData = {...globalState};
        tempData.affiliateFilter.typeName = typeName;
        tempData.affiliateFilter.status = statusRadio;
        handleGlobalState(tempData);
        handleCloseFilterDropDown();
    }
    
    const handleCancel = async() =>{
        const tempData = {...globalState};
        tempData.affiliateFilter.status = null;
        setStatusRadio(null);
        await affiliateTypeBoth();
        await handleGlobalState(tempData);
    }

    const handleClickOpenMenu = async (e: React.MouseEvent<HTMLInputElement>) =>{
        setAnchorEl(e.currentTarget);
        await affiliateTypeQuery();
    }

    const handleCloseMenu = ()=>{
        setAnchorEl(null);
    }

    const handleSelectAffiliateType = (type: AffiliateType) =>{
        setTypeName(type?.name);
        // setTypeId(type?.id);
        setAnchorEl(null)
    }

    const handleChangeStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStatusRadio(event.target.value);
    };

    return (
        <div className={styles.filterDropdown} >
            <div className={styles.top}>
                <FilterTitle handleCloseFilterDropDown={handleCloseFilterDropDown}/>
                <div className={styles.filterContainer}>
                    <div className={styles.container}>
                        <div className={styles.filterDetails}>
                            <div className={styles.textFieldFullMain}>
                                <div className={styles.titlePlaceholder}>
                                <b className={styles.event}>Affiliate Type</b>
                                </div>
                                <div className={styles.textField} onClick={handleClickOpenMenu}>
                                <div className={styles.container1}>
                                    <div
                                    className={
                                        typeName === "" ? styles.select : styles.leagueSelect
                                    }
                                    >
                                    {typeName ? typeName : '--Select--'}
                                    </div>
                                    <img
                                    className={styles.sharpOutlineDropdown}
                                    alt="dropdownIcon"
                                    src={dropdownIcon}
                                    />
                                </div>
                                </div>
                            </div>
                            
                            <div className={styles.validate}>
                                <div>
                                    <b className={styles.validate1}>Status</b>
                                </div>
                                <div
                                className={styles.radiogroup}
                                >
                                    <RadioGroup
                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                        name="controlled-radio-buttons-group"
                                        value={statusRadio}
                                        onChange={handleChangeStatus}
                                        sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        }}
                                    >
                                        <div>
                                            <FormControlLabel
                                                value = 'Active'
                                                control={
                                                <Radio
                                                    sx={{
                                                    color: "#B9BDC6",
                                                    "&.Mui-checked": {
                                                        color: "#5D75F8",
                                                    },
                                                                            
                                                    }}
                                                />
                                                }
                                                label=""
                                            />
                                            <span className={styles.radiovalid}>Active</span>
                                        </div>
                                        <div>
                                            <FormControlLabel
                                                value = 'Deactive'
                                                control={
                                                <Radio
                                                    sx={{
                                                    color: "#B9BDC6",
                                                    "&.Mui-checked": {
                                                        color: "#5D75F8",
                                                    },
                                                    
                                                    }}
                                                />
                                                }
                                                label=""
                                            />
                                            <span className={styles.radiovalid}>Deactive</span>
                                        </div>
                                    </RadioGroup>
                                </div>
                            </div>


                        </div>
                    </div>
                    <ResetApplyButtons handleCancel={handleCancel} handleSubmit= {handleSubmitManageFilter}/>
                </div>
            </div>
            <AffiliateTypeListMenu
                anchorEl ={anchorEl}
                open= {open}
                selectedType = {typeName}
                handleCloseMenu ={handleCloseMenu}
                handleSelectAffiliateType={handleSelectAffiliateType}
                affiliateTypeListData = {affiliateTypeListData}
            />
        </div>
    )
        
}

export default AffiliateFilterDropdown;

